module.exports = __webpack_public_path__ + "static/media/jira_server_site_url_example.2aafcf54.jpeg";